import { FC } from 'react';
import { Divider, Tag } from 'antd';
import styled from 'styled-components';
import {
  colorGreen,
  colorOrange,
  colorPurple,
  colorRepBg,
  colorRepBorder,
  colorYellow,
  dividerBorderColor,
} from '@atlas-frontend/design-tokens';
import { TextEllipsis } from '../../../common/components';
import { getAlgorithmSourceLabel } from '../utils';
import { AlgorithmSourceFormDataType } from './schema/types';

export interface AlgorithmSourceTagProps {
  algorithmSource: AlgorithmSourceFormDataType;
}

export const AlgorithmSourceTag: FC<AlgorithmSourceTagProps> = (props) => {
  const { algorithmSource } = props;

  return (
    <StyledTag className={algorithmSource.sourceType}>
      <TextEllipsis tooltip={getAlgorithmSourceLabel(algorithmSource)}>
        <AlgorithmSourceLabel algorithmSource={algorithmSource} />
      </TextEllipsis>
    </StyledTag>
  );
};

export interface AlgorithmSourceLabelProps {
  algorithmSource: AlgorithmSourceFormDataType;
}

const AlgorithmSourceLabel: FC<AlgorithmSourceLabelProps> = (props) => {
  const { algorithmSource } = props;

  const {
    sourceName,
    sourceCode,
    alias,
    numberOfPreviousPeriod = 0,
  } = algorithmSource;

  return (
    <>
      {alias && (
        <>
          <span>{alias}</span>
          <StyledDivider type="vertical" />
        </>
      )}
      <span>{`${sourceCode}${
        numberOfPreviousPeriod > 0
          ? `[T+${numberOfPreviousPeriod}]`
          : numberOfPreviousPeriod < 0
          ? `[T${numberOfPreviousPeriod}]`
          : ''
      } - ${sourceName}`}</span>
    </>
  );
};

const StyledTag = styled(Tag)`
  margin: 0;
  max-width: 200px;

  .ant-typography {
    height: 100%;
  }

  &:is(.DB) {
    border-color: ${colorOrange[3]};
    background-color: ${colorOrange[2]};
  }
  &:is(.IN) {
    border-color: ${colorGreen[3]};
    background-color: ${colorGreen[2]};
  }
  &:is(.OUTPUT) {
    border-color: ${colorYellow[2]};
    background-color: ${colorYellow[1]};
  }
  &:is(.INTERMEDIATE) {
    border-color: ${colorPurple[4]};
    background-color: ${colorPurple[2]};
  }
  &:is(.REPORT) {
    border-color: ${colorRepBorder};
    background-color: ${colorRepBg};
  }
`;

const StyledDivider = styled(Divider)`
  width: 0;
  min-width: 0;
  border-inline-start: 1px solid ${dividerBorderColor};
  margin: 0 7px !important;
  min-height: 100%;
`;
